export default __webpack_public_path__ + "static/media/bgimg.c6408304.jpg";